import { IItem } from '@characterInventory/components/Avatar/Avatar.type';
import { getAndFormatWornItems } from '@services/inventory/inventory.services';
import { EToastUUID } from '@store/toastsStore/toastsStore.enum';
import { useQuery } from '@tanstack/react-query';
import useIsLoggedIn from 'src/apis/queries/useIsLoggedIn';
import useUserPersonalData from 'src/apis/queries/useUserPersonalData';
import { ERROR } from 'src/texts/feedbackMessages';
import { itemsKeys } from '../character.queriesKeys';

const useWornItems = <TReturnType = IItem[]>(select?: (data: IItem[]) => TReturnType) => {
	const { isLoggedIn } = useIsLoggedIn();
	const { avatarType } = useUserPersonalData();

	const { data: wornItems, ...queryResult } = useQuery({
		queryKey: itemsKeys.wornItems(avatarType),
		queryFn: () => getAndFormatWornItems(avatarType),
		enabled: isLoggedIn,
		select,
		meta: {
			errorToast: {
				uuid: EToastUUID.errorLoadingWornItems,
				title: ERROR.genericToastTitle,
				message: ERROR.character.loadingWornItems
			}
		}
	});

	return { wornItems, ...queryResult };
};

export { useWornItems };
